import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/IceCream/IceCream.css';

function WelcomeIceCream() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'IceCream Photobooth';
  }, []);

  return (
    <div className="IceCreamBg" style={{ backgroundImage: "url('/img/IceCream/Background.PNG')" }}>
      <div className="IceCreamWelcome">
        <img src="/img/IceCream/logo.png" alt="IceCream Logo" className="IceCreamLogo" />
        <button
          className="IceCreamStartButton"
          onClick={() => navigate('/icecream/frame-selection')}
        >
          Start
        </button>
      </div>
    </div>
  );
}

export default WelcomeIceCream;
